import ProfessionalDirectory from '../components/ProfessionalDirectory'
import PageHero from '../components/PageHero'
import SEO from '../components/SEO'
import SectionHeading from '../components/SectionHeading'
import { directoryStructuredData } from '../config/schema'

export default function Directory() {
  return (
    <>
      <SEO page="directory" structuredData={directoryStructuredData} />
      <PageHero
        index="04"
        eyebrow="Professional directory"
        title="Independent beauty professionals in Ocala"
        description="Explore the professionals and businesses working from Diamond Suites Ocala."
        image="directory-banner.webp"
        imagePosition="52% center"
      />
      <section className="section">
        <div className="container">
          <SectionHeading
            index="01"
            eyebrow="Eight private suites"
            title="Find the professional for your next appointment."
            description="Select a profile for complete approved details and contact information."
            align="center"
          />
          <ProfessionalDirectory />
          <p className="directory-note">
            Each provider is an independent business and manages their own schedule, services,
            pricing, booking, and payment policies. Directory details are shown only where they
            have been provided.
          </p>
        </div>
      </section>
    </>
  )
}
